import React from 'react';
import { Tooltip } from 'react-tippy';
import 'react-tippy/dist/tippy.css';

export default ({ title, className }) => (
    <Tooltip
        title={title}
        position="bottom"
        trigger="click"
        className={className}
        animation="fade"
        arrow={true}
    >
        <svg className="icon icon-info tooltip-icon">
            <use xlinkHref="#icon-info" />
        </svg>
    </Tooltip>
);



// WEBPACK FOOTER //
// ./src/components/ui/tooltip.js